<div *ngIf="party" class="flex card " >
    <p-card class="flex overflow-y-scroll">
        <ng-template pTemplate="header">
            <div class="flex flex-row flex-row-reverse p-1 pr-6">
                <p-button *ngIf="activeSubmission" icon="pi pi-file-import" [rounded]="true" [text]="true" [raised]="true" (onClick)="fillFromSubmission()"></p-button>
                <p-button icon="pi pi-eraser" [rounded]="true" [text]="true" [raised]="true" (onClick)="clearForm()" class="mr-2 ml-2"></p-button>
            </div>
        </ng-template>
        <div>
            <div class="flex grid">
                <div class="field mt-2 col-5">
                    <span>
                        <p-floatLabel>
                            <input id="firstName" pInputText [(ngModel)]="party.firstName" class="w-full"/>
                            <label for="firstName">First Name</label>
                        </p-floatLabel>
                    </span>
                </div>
                <div class="field mt-2 col-2">
                    <span>
                        <p-floatLabel>
                            <input id="mi" pInputText [(ngModel)]="party.middleInitial" class="w-full" />
                            <label for="mi">M.I.</label>
                        </p-floatLabel>
                    </span>
                </div>
                <div class="field mt-2 col-5">
                    <span>
                        <p-floatLabel>
                            <input id="lastName" pInputText [(ngModel)]="party.lastName" class="w-full" />
                            <label for="lastName">Last Name</label>
                        </p-floatLabel>
                    </span>
                </div>
                <div class="field mt-2 col-3">
                    <span>
                        <p-floatLabel>
                            <p-calendar appendTo="body" id="dob" [(ngModel)]="party.dateOfBirth" />
                            <label for="dob">Date Of Birth</label>
                        </p-floatLabel>
                    </span>
                </div>
                <div class="field mb-4 col-12">
                    <div class="flex align-items-center">
                        <p-checkbox [(ngModel)]="party.optedInToStatusUpdates" binary="true"
                            inputId="optedInToStatusUpdates"></p-checkbox>
                        <label for="optedInToStatusUpdates" class="ml-2">Injured worker has opted in for email updates</label>
                    </div>
                </div>
            </div>

            <p-panel header="Addresses" [toggleable]="true" collapsed>
                <div class="flex flex-wrap align-items-stretch">

                    <div *ngFor="let address of party.addresses" class="w-6 flex flex-column card p-2">
                        <p-card>
                            <ng-template pTemplate="header">
                                <div class="flex flex-row-reverse gap-2 w-full align-items-center p-3">
                                    <p-button icon="pi pi-trash" text rounded (onClick)="deleteAddress(address)"></p-button>
                                    <p-button *ngIf="editedAddresses.includes(address.id) && party.id > 0 " icon="pi pi-save" text rounded (onClick)="saveAddress(address)"></p-button>

                                    <p-button *ngIf="address.id > 0 && address.addressType>0" icon="pi pi-star" text rounded (onClick)="makeAddressPrimary(address)"></p-button>
                                    <p-button *ngIf="address.id > 0 && address.addressType == 0" icon="pi pi-star-fill" text rounded disabled></p-button>
                                </div>
                            </ng-template>

                            <div class="w-full m-1 p-1">
                                <div class="field">
                                    <p-floatLabel>
                                        <input id="street1" pInputText [(ngModel)]="address.location.street1" class="w-full" (change)="markAddressAsEdited(address)"/>
                                        <label for="street1">Street 1</label>
                                    </p-floatLabel>
                                </div>
                                <div class="field pt-2">
                                    <p-floatLabel>
                                        <input id="street2" pInputText [(ngModel)]="address.location.street2" class="w-full" (change)="markAddressAsEdited(address)" />
                                        <label for="street2">Street 2</label>
                                    </p-floatLabel>
                                </div>
                                <div class="flex grid">
                                    <div class="field col-6 pt-2">
                                        <p-floatLabel>
                                            <input id="city" pInputText [(ngModel)]="address.location.city" class="w-full" (change)="markAddressAsEdited(address)"/>
                                            <label for="city">City</label>
                                        </p-floatLabel>
                                    </div>
                                    <div class="field col-3 pt-2">
                                        <p-floatLabel>
                                            <input id="state" pInputText [(ngModel)]="address.location.state" class="w-full" (change)="markAddressAsEdited(address)"/>
                                            <label for="state">State</label>
                                        </p-floatLabel>
                                    </div>
                                    <div class="field col-3 pt-2">
                                        <p-floatLabel>
                                            <input id="zipCode" pInputText [(ngModel)]="address.location.zipCode" class="w-full" (change)="markAddressAsEdited(address)" />
                                            <label for="zipCode">Zip</label>
                                        </p-floatLabel>
                                    </div>
                                </div>        
                            </div> 
                        </p-card>
                    </div>
                    
                    <div class="flex w-6 align-items-center justify-content-center">
                        <p-button icon="pi pi-plus" text rounded (onClick)="addBlankAddress($event)"></p-button>
                    </div>
                </div>
            </p-panel>
            <p-panel header="Email/Phone" [toggleable]="true" collapsed styleClass="pt-2">
                <div class="flex flex-row gap-2">
                    <div class="flex flex-column w-6 justify-content-start align-items-center">
                        <div><h4>Emails</h4></div>
                        <div *ngFor="let email of party.emails" class="w-full flex justify-content-center">
                            <p-card class="pt-1 w-full">
                                <ng-template pTemplate="header">
                                    <div class="flex flex-row-reverse gap-2 w-full align-items-center p-3">
                                        <p-button icon="pi pi-trash" text rounded (onClick)="deleteEmail(email)"></p-button>
                                        <p-button *ngIf="editedEmails.includes(email.id)  && party.id > 0" icon="pi pi-save" text rounded (onClick)="saveEmail(email)"></p-button>
    
                                        <p-button *ngIf="email.id > 0 && email.emailType>0" icon="pi pi-star" text rounded (onClick)="makeEmailPrimary(email)"></p-button>
                                        <p-button *ngIf="email.id > 0 && email.emailType == 0" icon="pi pi-star-fill" text rounded disabled></p-button>
                                    </div>
                                </ng-template>
                                <div class="w-full m-1 p-1">
                                    <div class="field">
                                        <p-floatLabel>
                                            <input id="email" pInputText [(ngModel)]="email.emailAddress" class="w-full" (change)="markEmailAsEdited(email)"/>
                                            <label for="email">Email</label>
                                        </p-floatLabel>
                                    </div>
                                </div>
                            </p-card>
                            
                        </div>

                        <p-button icon="pi pi-plus" text rounded (onClick)="addBlankEmail($event)"></p-button>
    
                    </div>
                    <div class="flex flex-column w-6 justify-content-start align-items-center">
                        <div><h4>Phones</h4></div>
                        <div *ngFor="let phone of party.phones" class="w-full flex justify-content-center">
                            <p-card class="pt-1 w-full">
                                <ng-template pTemplate="header">
                                    <div class="flex flex-row-reverse gap-2 w-full align-items-center p-3">
                                        <p-button icon="pi pi-trash" text rounded (onClick)="deletePhone(phone)"></p-button>
                                        <p-button *ngIf="editedPhones.includes(phone.id)  && party.id > 0" icon="pi pi-save" text rounded (onClick)="savePhone(phone)"></p-button>
    
                                        <p-button *ngIf="phone.id > 0 && phone.phoneType>0" icon="pi pi-star" text rounded (onClick)="makePhonePrimary(phone)"></p-button>
                                        <p-button *ngIf="phone.id > 0 && phone.phoneType == 0" icon="pi pi-star-fill" text rounded disabled></p-button>
                                    </div>
                                </ng-template>
                                <div class="flex w-full m-1 p-1 align-items-center flex-row">
                                    <div class="field w-7 pr-2">
                                        <p-floatLabel>
                                            <p-inputMask #pn id="phoneNumber" mask="(999) 999-9999? x9999999999"  unmask [(ngModel)]="phone.phoneNumber"  placeholder="(XXX)-XXX-XXXX" styleClass="w-full" (onComplete)="markPhoneAsEdited(phone)" />
                                            <label for="phoneNumber">Phone Number</label>
                                        </p-floatLabel>
                                    </div>
                                    <div class="field flex align-items-center">
                                            <p-checkbox id="smsCapable" binary [(ngModel)]="phone.smsCapable" (onChange)="markPhoneAsEdited(phone)" />
                                            <label for="smsCapable">SMS Capable</label>
                                    </div>
                                </div>
                            </p-card>
                            
                        </div>
                        <p-button icon="pi pi-plus" text rounded (onClick)="addBlankPhone($event)"></p-button>
    
                    </div>
                </div>
               
            </p-panel>

            <div class="flex mt-2 col-12 justify-content-center " >
                <span [pTooltip]="fieldsMissing()" [tooltipDisabled]="fieldsMissing()==''">

                <p-buttonGroup>
                    <p-button  label="Save" icon="pi pi-check" (onClick)="saveButtonPressed($event)" [disabled]="!allowSave()"></p-button>
                    <p-button label="Cancel" icon="pi pi-times" severity="danger" (onClick)="cancelButtonPressed($event)"></p-button>
                </p-buttonGroup>
            </span>

            </div>
        </div>
       
    </p-card> 
</div>
